// In case of change, please update the value in the libs/tailwind-presets/src/screens.js file

export const SCREENS = {
  xs: 475,
  sm: 576,
  md: 786,
  lg: 1024,
  xl: 1440,
};
